import { zIndex } from "@/styles/variants";
import { buttonVariants } from "@markeroo/theme";
import { useAuthStore } from "@/stores/auth";
import { useShallow } from "zustand/shallow";
import { stopImpersonation } from "@/api/admin";
import { useState } from "react";
import { useNotification } from "@/providers/NotificationProvider";
import { notifications, ui } from "@/strings";
import type { NotificationKind } from "@/providers/NotificationProvider";

export function ImpersonationBanner() {
  const { user, login } = useAuthStore(useShallow((state) => ({
    user: state.user,
    login: state.login,
  })));
  const [isStoppingImpersonation, setIsStoppingImpersonation] = useState(false);
  const { show } = useNotification();
  const TOAST_ERROR: NotificationKind = "error";

  if (!user?.impersonator) {
    return null;
  }

  const handleStopImpersonation = () => {
    setIsStoppingImpersonation(true);
    void (async () => {
      try {
        const response = await stopImpersonation();
        login({
          accessToken: response.accessToken,
          user: response.user,
        });
        // Force full page reload to refresh all content
        window.location.href = "/";
      } catch {
        show(notifications.auth.stopImpersonationFailed, TOAST_ERROR);
        setIsStoppingImpersonation(false);
      }
    })();
  };

  return (
    <div
      className="sticky top-0 left-0 right-0 bg-semantic-warning text-white px-4 py-2 flex items-center justify-center gap-4 shadow-lg"
      style={{ zIndex: zIndex.sticky }}
    >
      <div className="flex items-center gap-2">
        {/* eslint-disable-next-line no-restricted-syntax */}
        <span className="font-semibold">⚠️ {ui.labels.impersonating}</span>
        <span>{user.email}</span>
      </div>
      <button
        onClick={handleStopImpersonation}
        disabled={isStoppingImpersonation}
        className={`${buttonVariants.secondary} !bg-white !text-semantic-warning-dark hover:!bg-surface-secondary`}
      >
        {isStoppingImpersonation ? ui.actions.stopping : ui.actions.stopImpersonation}
      </button>
    </div>
  );
}
